import { useTheme, type ThemeChoice } from '../lib/theme';

/**
 * Three-way theme selector (Light / Dark / Auto) rendered as a Bootstrap
 * dropdown. The trigger icon reflects the *resolved* theme so users can
 * see at a glance which theme is currently applied.
 */
export default function ThemeToggle() {
  const { choice, resolved, setChoice } = useTheme();

  const icon = resolved === 'dark' ? 'bi-moon-stars-fill' : 'bi-sun-fill';
  const label = `Theme: ${choice}`;

  const options: { value: ThemeChoice; label: string; icon: string }[] = [
    { value: 'light', label: 'Light', icon: 'bi-sun-fill' },
    { value: 'dark', label: 'Dark', icon: 'bi-moon-stars-fill' },
    { value: 'auto', label: 'Auto (system)', icon: 'bi-circle-half' },
  ];

  return (
    <div className="dropdown">
      <button
        type="button"
        className="btn btn-link nav-link px-2"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-label={label}
        title={label}
      >
        <i className={`bi ${icon}`} aria-hidden="true"></i>
        <span className="visually-hidden">{label}</span>
      </button>
      <ul className="dropdown-menu dropdown-menu-end">
        {options.map((opt) => {
          const active = choice === opt.value;
          return (
            <li key={opt.value}>
              <button
                type="button"
                className={`dropdown-item d-flex align-items-center gap-2${active ? ' active' : ''}`}
                aria-pressed={active}
                onClick={() => setChoice(opt.value)}
              >
                <i className={`bi ${opt.icon}`} aria-hidden="true"></i>
                <span>{opt.label}</span>
                {active && <i className="bi bi-check2 ms-auto" aria-hidden="true"></i>}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
